import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { TUserServiceError, TMlmPvBusinessPackResponse } from 'services/UserService'
import { QueryCacheKeys } from 'enums'
import { UserService } from 'services'
import * as userSelectors from 'containers/User/user-selectors'
import { getRequestError } from 'utils/helpers'

export type TFetchFnParams = null
export type TFetchFnResponse = TMlmPvBusinessPackResponse
export type TFetchFnError = AxiosError<TUserServiceError, TFetchFnParams>
export type TQueryKey = string[]
export type TError = [string, TFetchFnError]
export type TQueryFnOpts = UseQueryOptions<TFetchFnResponse, TError, TFetchFnResponse, TQueryKey>

const key = QueryCacheKeys.mlmPvBusinessPack

/**
 * Хук API получить данные по бизнес-паку
 */
export default function useFetchMlmPvBusinessPack(opts: TQueryFnOpts = {}) {
    const { t } = useTranslation()
    const user = useSelector(userSelectors.user)

    return useQuery([`${key}-${user.id}`], () => {
        return UserService.fetchMlmPvBusinessPack()
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject([getRequestError(err) || t('update_error'), err])
            })
    }, opts)
}
